import { render } from "./MenuEntry.vue?vue&type=template&id=79c7cc6c"
import script from "./MenuEntry.vue?vue&type=script&lang=js"
export * from "./MenuEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__